import { useTranslation } from "react-i18next";
import { Box, Button, Menu, MenuItem, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import LanguageIcon from "@mui/icons-material/Language";
import enFlag from "../assets/en_flag.png";
import mneFlag from "../assets/me_flag.png";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

export default function ChangeLanguageComponent() {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    const lang = window.localStorage.getItem("locale-language");
    if (lang === null) {
      window.localStorage.setItem("locale-language", "mne");
    } else {
      i18n.changeLanguage(lang);
    }
  }, []);

  function changeLanguage(langauge) {
    i18n.changeLanguage(langauge);
    window.localStorage.setItem("locale-language", langauge);
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const languageArr = [
    {
      id: 1,
      name: "EN",
      icon: enFlag,
      language: "en",
    },
    {
      id: 2,
      name: "MNE",
      icon: mneFlag,
      language: "mne",
    },
  ];

  const currentLang = i18n.language;
  const alternateLang = currentLang === "en" ? "mne" : "en";
  const alternateLangData = languageArr.find((lang) => lang.language === alternateLang);

  if (isMobile) {
    return (
      <Button
        sx={{
          paddingLeft: 0,
          border: "none",
          color: "#09375c",
          minWidth: 32,
        }}
        onClick={() => changeLanguage(alternateLangData.language)}
      >
        <Stack direction={"row"} alignItems={"center"} spacing={1}>
          <Box
            component="img"
            alt={alternateLangData.name}
            src={alternateLangData.icon}
            sx={{ width: 25, height: 15 }}
          />
          <Typography variant="body2">{alternateLangData.language.toUpperCase()}</Typography>
        </Stack>
      </Button>
    );
  }

  return (
    <>
      <Button
        sx={{
          border: "none",
          color: "#09375c",
          minWidth: 32,
        }}
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <LanguageIcon />
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        sx={{ marginTop: 0.8 }}
      >
        <Box sx={{ paddingX: 0.5 }}>
          {languageArr.map((item) => {
            return (
              <MenuItem
                key={item.id}
                onClick={() => {
                  handleClose();
                  changeLanguage(item.language);
                }}
              >
                <Stack direction={"row"} alignItems={"center"} spacing={1}>
                  <Box
                    component="img"
                    alt={item.name}
                    src={item.icon}
                    sx={{ width: 25, height: 15 }}
                  />
                  {item.language === "mne" ? (
                    <Typography variant="body2">{`MNE`}</Typography>
                  ) : (
                    <Typography variant="body2">{`EN`}</Typography>
                  )}
                </Stack>
              </MenuItem>
            );
          })}
        </Box>
      </Menu>
    </>
  );
}
